import React, { useEffect } from "react";
import { path } from "../../../../constants/path";
import { useState } from "react";
import useControlPanel from "src/hooks/useControlPanel";
import Pagination from "src/components/Pagination/Pagination";
import { useMemo } from "react";
import { useCallback } from "react";
import ContextDeviceTable from "../Table/ContextDeviceTable";
import FLFContextDeviceControlPanel from "../ControlPanel/FLFContextDeviceControlPanel";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import { getFLFContextDetailByClause } from "src/apis/FLF/context.api";

const ContextDevice = ({ clause, contextId, setContext }) => {
  const { numberPage, limit, status, startIndex, endIndex, handleChangePage } =
    useControlPanel();

  // authorization button action
  const permissionsAccessControl = useGetPermissionAccessControl();

  const [listDevice, setListDevice] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    getFLFContextDetailByClause(contextId, { clause }, (result) => {
      setListDevice([...result.devices]);
    });
  }, [clause, contextId]);

  const handleDelete = (deviceDeleted) => {
    console.log("implement delete context device");
    // NotifyConfirm("warning", "Are you delete it ?", (result) => {
    //   if (result.isConfirmed) {
    //     const foundDeviceIndex = listDevice.findIndex(
    //       (device) => device.id === deviceDeleted.id
    //     );
    //     if (foundDeviceIndex !== -1) {
    //       const data = {
    //         deviceId: deviceDeleted.id,
    //         contextId,
    //         clause,
    //       };
    //       removeFLFContextDevice(data, (result) => {
    //         getFLFContextDetailByClause(contextId, { clause }, (result) => {
    //           const calculateNumberPage = Math.ceil(
    //             result.devices.length / limit
    //           );
    //           setListDevice([...result.devices]);
    //           setNumberPage(calculateNumberPage);
    //         });
    //         setCurrentActionCache(CACHE_CONTEXT_DEVICE);
    //       });
    //     }
    //   }
    // });
  };

  const handleOpenPopup = useCallback((isOpen, item = null) => {
    setOpenPopup(isOpen);
  }, []);

  const listItem = useMemo(
    () => listDevice.slice(startIndex, endIndex),
    [endIndex, listDevice, startIndex]
  );

  return (
    <div className="row" style={{ width: "50%" }}>
      <div className="col-12">
        <h2
          style={{ textAlign: "center", margin: "10px 0" }}
        >{`${clause} clause`}</h2>

        <FLFContextDeviceControlPanel
          handleOpenPopup={handleOpenPopup}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          listDevice={listDevice}
          setListDevice={setListDevice}
          clause={clause}
          contextId={contextId}
          setContext={setContext}
        />

        <ContextDeviceTable
          permissionsAccessControl={permissionsAccessControl}
          data={listItem}
          handleOpenPopup={handleOpenPopup}
          handleDelete={handleDelete}
          status={status}
        />

        <Pagination
          pathname={path.flfContext}
          page={numberPage}
          handleChangePage={(page) => handleChangePage(page)}
          limit={limit}
          pageSize={listDevice.length}
        />
      </div>
    </div>
  );
};

export default ContextDevice;
